
export const DATE_FORMAT_DISPLAY = 'dd-MMM-yyyy';

export const formatDateToStandard = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return 'N/A';
    
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.warn('Invalid date provided to formatDateToStandard:', dateInput);
    return 'N/A';
  }
};

export const formatDateTimeToStandard = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return 'N/A';
    
    const formattedDate = formatDateToStandard(date);
    const time = date.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    return `${formattedDate} ${time}`;
  } catch (error) {
    console.warn('Invalid date provided to formatDateTimeToStandard:', dateInput);
    return 'N/A';
  }
};

export default formatDateToStandard;
